import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class GradeTimingStore {
  gradeTiming = [];
  getClass = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      getClass: observable,
      gradeTiming: observable,
      total: observable,
      loading: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getAllClass: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      deviceGrpOffSet: 0,
      offset: offset,
      limit: limit,
      deviceGrpSize: 10,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("gradeTiming/getGradeList", {
        params: postData,
      });

    this.gradeTiming = response?.data?.Grades;

    this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }
  async deleteRecord({ grade_Id }) {
    // var postData = {"tokenId":"","gradeTime":{"grade_Id":grade_Id}}
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("gradeTiming/deleteGrade", {
        params: {
          grade_Id: grade_Id,
        },
      });
    return response;
  }

  async addData(postData) {
    var gradeDetails = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("gradeTiming/updateGrade", gradeDetails);

    return response.data;
  }
  async getGradeTimingData({ grade_Id }) {
    var postData = { grade_Id: grade_Id, limit: 1, offset: 0 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("gradeTiming/getGradeList", {
        params: postData,
      });

    return response.data.Grades[0];
  }

  async getAllClass() {
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=notification&a=getAllClass",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("notifications/getAllClass");

    this.getClass = response?.data?.data;
    return response?.data?.data;
  }
}

export default GradeTimingStore;
